import PropTypes from 'prop-types';
import { instanceToPlain, plainToInstance } from 'class-transformer';
import FormStepper from 'components/form-stepper/FormStepper';
import { TypeMode } from 'constants/TypeMode';
import StandardModalForm from 'components/shared/StandardModalForm';

// eslint-disable-next-line react/prop-types
const EditMissionPointModalForm = ({
    config,
    entity,
    defaultValue,
    open,
    service,
    actionType,
    title,
    onClose,
}) => {
    const handleOnClose = action => {
        onClose(action);
    };

    const handleOnSubmit = async (data, successCallback, errorCallback) => {
        let postData = plainToInstance(entity, data);
        await actionType(postData);
        onClose();
    };

    return (
        <StandardModalForm
            mode={TypeMode.Edit}
            formConfig={config}
            defaultValue={instanceToPlain(defaultValue)}
            onClose={handleOnClose}
            onSubmit={handleOnSubmit}
            open={open}
            title={title}
        >
            {({ formConfig, methods, watch, defaultValue, mode }) => (
                <FormStepper
                    forms={formConfig}
                    watch={watch}
                    mode={mode}
                    methods={methods}
                    defaultValue={defaultValue}
                    showHeader={false}
                />
            )}
        </StandardModalForm>
    );
};
EditMissionPointModalForm.propTypes = {
    service: PropTypes.object,
    onUpdate: PropTypes.func,
    config: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            config: PropTypes.func.isRequired,
        }),
    ).isRequired,
    entity: PropTypes.func.isRequired,
    defaultValue: PropTypes.object,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string,
};
export default EditMissionPointModalForm;
